<template lang="pug">
  div#company-view
    mainHeader
    div.box
      div.has-text-centered
        strong.title About Us
      hr
      div.columns.is-vcentered
        div.column.is-1
        div.column.is-4
          img(:src="`${baseUrl}img/22.jpg`")
        div.column.is-4.left-margin
          div.columns.is-vcentered
            div.column.has-text-justified
              p Η MindCore, μια νεοσύστατη και ταχέως αναπτυσσόμενη εταιρεία με έδρα την Αθήνα, ιδρύθηκε το φθινόπωρο του 2014 από το μηχανικό αυτοματισμού Γιώργο Παπαβασιλείου. Ειδικεύεται στον κλάδο των ηλεκτρονικών συστημάτων, του αυτοματισμού και της μηχατρονικής. 
              p Στόχος της MindCore είναι η ανάπτυξη και προώθηση τεχνολογιών που παρέχουν λύσεις και βοηθούν τον άνθρωπο σε καθημερινά προβλήματα.
              p Τομείς στους οποίους δραστηριοποιείται είναι η έρευνα, ο σχεδιασμός και η ανάπτυξη ηλεκτρονικών συστημάτων και προϊόντων, τόσο στο hardware, στο software καθώς και στο μηχανολογικό σχεδιασμό που απαιτείται για εφαρμογές μηχατρονικής.
    

    Footer

</template>

<script>
import MainHeader from "@/components/MainHeader.vue";
import Footer from "@/components/Footer.vue";

export default {
  name: "about-us",
  components: {
    MainHeader,
    Footer
  },
  data: function() {
    return {
      baseUrl: process.env.BASE_URL
    };
  }
};
</script>

<style scoped>
.left-margin {
  margin: 0 auto;
}

p {
  margin-bottom: 1rem;
}

.box {
    background-color: #E8E8E8;
}

hr {
    border-bottom-style: solid;
    border-bottom-color: rgb(111, 111, 111);
    border-bottom-width: 1px;
    border-bottom-width: 80%;
    margin-bottom: 2rem;
}

</style>

